import script from "./TiktokUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./TiktokUp.vue?vue&type=script&lang=ts&setup=true"

import "./TiktokUp.vue?vue&type=style&index=0&id=093599dd&lang=scss"

const __exports__ = script;

export default __exports__